import { Component, Event, EventEmitter, getAssetPath, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../../../utils/Stores/init-store';
import { MessagesStore } from '../../../../../utils/Stores/messages-store';
import { Store } from '../../../../../utils/Stores/store';

@Component({
  tag: 'bot-event-continue-component',
  styleUrl: 'bot-event-continue-module.scss',
  shadow: true,
})
export class ModuleBotEventContinueConversation {
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  @State() loader = false;

  private loadingReset = false;

  private resetConversation() {
    if (this.loadingReset) {
      return;
    }

    this.loader = true;

    this.loadingReset = true;

    let url = `/api/components/chatbot/reset?lang=${wcShared?.store?.getLang()}`;
    url += helpdeskCommon.urlFormatFaq();

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          return r.json().then((response) => {
            this.loadingReset = false;
            Store?.set('bot_id', response.data.bot_id);
            Store?.set('channel_id', response.data.channel_id);
            this.sectionChangeEvent.emit(['landing']);

            MessagesStore?.set('messages', response?.data?.messages);
            Store?.set('is_active', true);
            InitStore.set('init', {
              ...InitStore.get('init'),
              continue_event: true,
            });
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private continue() {
    this.loader = true;
    this.sectionChangeEvent.emit(['landing']);
    this.sectionChangeEvent.emit(['chat']);
    Store?.set('is_active', true);
    InitStore.set('init', {
      ...InitStore.get('init'),
      continue_event: true,
    });
  }

  render() {
    if (this.loader) {
      return (
        <div class="loader-container">
          <module-loader-component />
        </div>
      );
    } else {
      return (
        <Host>
          <div
            class={{
              'error-unauthorized-modal': true,
              'error-unauthorized-modal--full': Store?.get('is_full'),
            }}
          >
            <div class="chat-message">
              <div class="chat-message__user">
                <img
                  class="chat-message__user--avatar"
                  src={getAssetPath('./../assets/beep/' + Store?.get('beepAvatar')?.url)}
                  alt={Store?.get('beepAvatar')?.name}
                />
                <span>{Store?.get('beepAvatar')?.name}.</span>
              </div>
              <div class="chat-message__message">
                <div class="message__text">
                  {wcShared?.translate(
                    'Souhaitez-vous reprendre votre derniere conversation avec moi ?',
                  )}
                </div>
                <div class="message__actions">
                  <button onClick={() => this.resetConversation()}>
                    {wcShared?.translate('Non')}
                  </button>
                  <button onClick={() => this.continue()}>{wcShared?.translate('Oui')}</button>
                </div>
              </div>
            </div>
          </div>
        </Host>
      );
    }
  }
}
